import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import {
  TributacaoDto,
  TributacaoFiltrarDto,
  TributacaoFiltrarSchema,
} from "./Tributacao.Dto";
import { useToast } from "src/componentes";
import { useEffect, useState } from "react";
import { MapearErrosServidor } from "src/hook/Functions";
import { TributacaoFiltrar } from "src/services/Fiscal.Service";

const TributacaoCode = () => {
  const [data, setData] = useState<TributacaoDto[] | undefined>([]);
  const [loading, setLoading] = useState(false);
  const { showToast } = useToast();
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
  } = useForm<TributacaoFiltrarDto>({
    resolver: yupResolver(TributacaoFiltrarSchema),
    defaultValues: { tipoFiltro: 0 },
  });

  useEffect(() => {
    const controller = new AbortController();
    const Load = async () => {
      handleSubmit(onSubmit)();
    };
    Load();
    return () => {
      controller.abort();
    };
  }, []);

  const onSubmit = async (data: TributacaoFiltrarDto, e: any) => {
    setLoading(true);
    try {
      const response = await TributacaoFiltrar(data);
      if (response.data.success) {
        const data = response.data.data;
        setData(data);
        if (data.length === 0) {
          showToast({
            message: "Não encontrado",
            title: "Info",
            variant: "Info",
          });
        }
      } else {
        MapearErrosServidor(response.data.notifications, showToast);
      }
    } catch (error) {
      setData(undefined);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return {
    data,
    loading,
    register,
    handleSubmit,
    onSubmit,
    errors,
    setValue,
    getValues,
  };
};

export default TributacaoCode;
